import { Point } from "pixi.js";
import { DialogManagerLandscapeProperties } from "../landscape/DialogManagerLandscapeProperties";
/**
 * DialogManagerPortraitProperties.ts
 */
export class DialogManagerPortraitProperties extends DialogManagerLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.messageDialogProperties.scale = new Point(1, 1);
        this.responsibleGamingDialogProperties.position = new Point(512, 830);
    }
}
